import { useEffect } from 'react';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useValuation from '../../../config/Record/useValuation';
import { Auth } from '../../../config/configuration/react';
import { t, numStr } from '../../../components/common/Translate';
import { currencySign } from '../../../Utils/currencySign';

export const useMarket = (recordId) => {
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const vehicle = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle;
  const country = useSelector((state) => state.reduxRecords.data[recordId])?.record?.country;
  const active = Auth.isAllowedToAccessMarket() && country !== 'NL';
  const countryPosId = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.countryId);
  const { valuation, isLoading, updateVehicle: setVehicle } = useValuation(record, active);
  const history = useHistory();

  useEffect(() => {
    if (vehicle) {
      setVehicle(vehicle);
    }
  }, [JSON.stringify(vehicle)]);

  const goToMarket = () => {
    if (!active) return;
    history.push({
      pathname: `/files/${recordId}/market`,
      state: {
        ...history.location.state,
      },
    });
  };

  const labels = [];

  const corrected =
    (_.get(valuation, '_quotation.b2cMarketValue', 0) > 0 && _.get(valuation, '_quotation.b2cMarketValue')) ||
    _.get(valuation, '_quotation.corrected', null);
  if (corrected)
    labels.push({ label: t('market_value_corrected'), value: currencySign(numStr(corrected), null, countryPosId) });

  const tradeIn = _.get(valuation, '_quotation.tradeIn', null);
  if (tradeIn && Auth.country() === 'IT')
    labels.push({ label: t('trade_in_value'), value: currencySign(numStr(tradeIn), null, countryPosId) });

  const transactionSpread = _.get(valuation, '_marketInformation.transactionSpread', null);
  if (transactionSpread !== null)
    labels.push({ label: t('transactionSpread'), value: currencySign(numStr(transactionSpread), null, countryPosId) });

  return {
    valuation,
    isLoading,
    goToMarket,
    active,
    labels,
  };
};
